import { AccessGroup } from "./access-group.model";
import { Observable } from "rxjs/Observable";
import { CategoryApiFacade } from "../category/category.api-facade";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class AccessGroupApiFacade extends CategoryApiFacade<AccessGroup> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<AccessGroup> {
        return this.GET(`/accounts/${accountId}/accessgroups/${id}`, options)
            .map(object => new AccessGroup(object));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<AccessGroup>> {
        return this.CGET(`/accounts/${accountId}/accessgroups`, options)
            .map(objects => objects.map(object => new AccessGroup(object)));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.api-facade.ts